<script setup>
import { trans } from '@tools/translation';
</script>

<template>
  <p class="space-helper">
    {{ trans('space.contact.helper') }}
  </p>
</template>
